import { render, staticRenderFns } from "./B2bAssessments.vue?vue&type=template&id=12af02d2&scoped=true"
import script from "./B2bAssessments.vue?vue&type=script&lang=js"
export * from "./B2bAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af02d2",
  null
  
)

export default component.exports